import { cloneDeep, isEqual } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Actions',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    source: String
  },

  methods: {
    _inputFilter(value) {
      return cloneDeep(value)
    },

    transmitValue() {
      if (!isEqual(this.proxy, this.value)) {
        this.$emit('input', cloneDeep(this.proxy))
      }
    },

    updatePrice(price) {
      this.proxy.price = price
    }
  },

  render
}
